/**
 * News keys
 */
export const StorageNews = {
  newsFormData: 'news_form-data',
};
